import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import InstagramVideo from './SocialSectionInstagramVideo.vue';
import type { InstagramPostItem } from '~/components/sections/SocialSection/SocialSectionInstagram/SocialSectionInstagram.vue';

interface Props {
  item?: InstagramPostItem;
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialSectionInstagramItem',
  props: {
    item: null,
    index: null
  },
  emits: ["item-click", "autoplay-toggle"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'item-click', index: number): void;
  (e: 'autoplay-toggle', index: number, value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item?: InstagramPostItem;
  index: number;
};




const isVideo = (item?: InstagramPostItem) => {
  if (!item) return false;
  return (item.media_type || '').toUpperCase() === 'VIDEO';
};

return { __sfc: true,props, emit, isVideo, CdnImg, InstagramVideo }
}

})